import styled from 'styled-components';
import { colors } from '../../styles/colors';

interface IDateFiter {
  disable?: boolean,
};

export const DateFilterContainer = styled.div<IDateFiter>`
  display: flex;
  justify-content: center;
  align-items: center;
  
  position: fixed;
  z-index: 9999999;
  top: 0;
  left: 0;

  width: 100%;
  height: 100vh;
  background-color: rgba(33,37,41,0.4); 
  box-sizing: border-box;
  user-select: none;

  .container{
    display: flex;
    flex-flow: column;
    justify-content: space-between;

    position: relative;

    width: 296px;
    height: 299px;
    border-radius: 10px;
    padding: 32px;
    background-color: #F2F2F2;

    font-size:12px;

    .close{
      display: flex;
      justify-content: center;
      align-items: center;

      position: absolute;
      right: 0;
      top: -20px;

      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #BEBEBE;
      cursor: pointer;

      color: #F2F2F2;
    }

    .label{
      color: ${colors.grayDark};
      font-size: 10px;
    }

    .calendar{
      display: none;
      
      width: 100%;
      height: 167px;

      border: 1px solid #666;
      margin-bottom: 38px;
    }

    .section{
      display: flex;
      justify-content: center;

      width: 100%;
      font-weight: bold; 
      color: ${colors.blueDark};
    }

    .selectArea{
      width: 100%;

      .dateSelect{
        display: flex;
        justify-content: space-between;
        
        margin-top: 5px;
      }
    }

    .buttonArea{
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-top: 12px;

      button{
        font-weight: 700;
        width: 108px !important;
        font-size: 14px !important;
      }

      .closeBtn{
        border: 2px solid ${colors.greenDarkViveo};
        background-color: #FFF;
        color: ${colors.greenDarkViveo};
      }

      .searchBtn{
        background-color: ${({ disable }) => disable ? '#BEBEBE' : '#0E4C54'};
        cursor: ${({ disable }) => disable ? 'not-allowed' : 'pointer'};
        color: ${({ disable }) => disable ? '#FFFFFF' : ''};
      }
    }
  }
`;